<template>
  <a-spin :spinning="loading">
    <div class="spin-content">
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="FILTROS" key="1">
          <a-card>
            <a-row :gutter="16">
              <a-col v-bind="responsive.cTurnoCfg" :md="{span: 8}">
                <a-form :form="formCargar" @submit="cargarEmpleados">
                  <g-dropdown endpoint="hierarchy_lookup"
                              :decorator="['grupo', decoradores.valor_requerido]"
                              :formItemConfig="{label:'Grupo', 'label-col': {span: 4}, 'wrapper-col': {span: 20}}"
                              :params="grupoParams"
                              :selectedObj.sync="grupoSeleccionado"
                              @change="grupoCambiado"></g-dropdown>

                  <g-dropdown endpoint="hierarchy_lookup"
                              :decorator="['puesto', decoradores.valor_requerido]"
                              :formItemConfig="{label:'Puesto', 'label-col': {span: 4}, 'wrapper-col': {span: 20}}"
                              :selectedObj.sync="puestoSeleccionado"
                              :params="puestoParams"></g-dropdown>

                  <g-dropdown
                    v-if="visible_id_h_att3"
                    endpoint="hierarchy_lookup"
                    :decorator="['id_h_att3', {rules: [{required: false, message: 'Valor requerido'}]}]"
                    :formItemConfig="{label: $t('ID_H_ATT3'), 'label-col': {span: 4}, 'wrapper-col': {span: 20}}"
                    :params="id_h_att3">
                  </g-dropdown>


                  <a-form-item :wrapper-col="{sm: {span: 18, offset: 4}, md: {span: 24, offset: 4}}"
                               style="margin-bottom: 0;">
                    <a-button type="primary" html-type="submit">Cargar</a-button>
                    <a-divider v-if="$getConfigValue('MOSTRAR_INFO_CAMBIAR_TURNO', false) === 'SI'"/>
                    <a-badge :count="filasSeleccionadas.length"
                             :number-style="{
                                backgroundColor: '#ff4d4f',
                             }"
                             v-if="filasSeleccionadas.length > 0 && $getConfigValue('MOSTRAR_INFO_CAMBIAR_TURNO', false) === 'SI'">
                      <a-button type="danger" html-type="button" @click="eliminarTurnos">Eliminar turnos</a-button>
                    </a-badge>
                    <a-badge :count="filasSeleccionadas.length"
                             :number-style="{
                                backgroundColor: '#ff4d4f',
                             }"
                             v-if="filasSeleccionadas.length > 0 && $getConfigValue('MOSTRAR_INFO_CAMBIAR_TURNO', false) !== 'SI'"
                             style="margin-left: 10px;">
                      <a-button type="danger" html-type="button" @click="eliminarTurnos">Eliminar turnos</a-button>
                    </a-badge>
                    <a-badge :count="filasSeleccionadas.length"
                             :number-style="{ backgroundColor: '#1890ff' }"
                             v-if="filasSeleccionadas.length > 0 && roleCrearTurnoMasivo"
                             style="margin-left: 15px;">
                      <a-button type="primary" @click="abrirModalCrearTurnoMasivo">Crear turnos masivos</a-button>
                    </a-badge>
                    <br>
                    <!--                    <a-button v-if="filasSeleccionadas.length > 0 && filasSeleccionadas.length === 1 &&
                                                  roleAgregarComentario"
                                                  @click="abrirModalAgregarComentario">Agregar comentario por fecha
                                        </a-button>-->
                  </a-form-item>
                </a-form>
              </a-col>
              <a-col v-bind="responsive.cTurnoCfg" :md="{span: 0}">
                <a-divider/>
              </a-col>
              <a-col v-bind="responsive.cTurnoCfg" :md="{span: 16}">
                <a-card title="Cambio de turno" size="small"
                        v-if="$getConfigValue('MOSTRAR_INFO_CAMBIAR_TURNO', false) === 'SI'">
                  <a-row :gutter="16">
                    <a-form :form="formAplicar" @submit="aplicarSecuencia">
                      <a-col v-bind="responsive.cTurnoCfg" :md="{span: 12}">
                        <g-dropdown endpoint="shifts_type"
                                    :decorator="['turno', decoradores.valor_requerido]"
                                    :formItemConfig="{label:'Cambiar Turno', 'label-col': {sm: {span: 8}, md: {span: 8}}, 'wrapper-col':  {sm: {span: 16}, md: {span: 16}}}"
                                    :selectedObj.sync="turnoSeleccionado"></g-dropdown>
                      </a-col>
                      <a-col v-bind="responsive.cTurnoCfg" :md="{span: 6}">
                        <g-dropdown endpoint="hierarchy_lookup"
                                    :formItemConfig="{label:'Periodo', 'label-col':{sm: {span: 6}, md: {span: 8}}, 'wrapper-col': {sm: {span: 20}, md: {span: 16}}}"
                                    :decorator="['periodo', decoradores.valor_requerido]"
                                    :params="{h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true}">
                        </g-dropdown>
                      </a-col>
                      <a-col v-bind="responsive.cTurnoCfg" :md="{span: 12}">
                        <g-select :options="listas.iniciales"
                                  :decorator="['inicial', decoradores.valor_requerido]"
                                  :selectedObj.sync="inicial"
                                  :formItemConfig="{label:'Inicial', 'label-col':{sm: {span: 6}, md: {span: 8}}, 'wrapper-col': {sm: {span: 18}, md: {span: 16}}}"></g-select>
                      </a-col>
                      <a-col v-bind="responsive.cTurnoCfg" :md="{span: 12}">
                        <a-form-item
                          :wrapper-col="{sm: {span: 18, offset: 6}, md: {span: 24, offset: 0}}">
                          <a-input v-model="secuencia" disabled/>
                        </a-form-item>
                      </a-col>
                      <a-col v-bind="responsive.cTurnoCfg" :md="{span: 24}">
                        <a-form-item style="margin-bottom: 0;"
                                     :label-col="{sm: {span: 6}, md: {span: 8}}"
                                     :wrapper-col="{sm: {span: 18, offset: 6}, md: {span: 24, offset: 8}}">
                          <a-button type="primary" html-type="submit">Aplicar</a-button>
                        </a-form-item>
                      </a-col>
                    </a-form>
                  </a-row>
                </a-card>
                <a-card title="Información de tipo de turnos" size="small">
                  <!-- Botón para activar el popover -->
                  <a-popover trigger="click" placement="topRight">
                    <a-button>Tipos de turnos</a-button>
                    <template #content>
                      <div v-html="popoverContent"></div>
                    </template>
                  </a-popover>
                </a-card>
              </a-col>
            </a-row>
          </a-card>
          &nbsp;
          <a-table v-if="fechaSelector === 'mes'" size="small" :columns="columns" :dataSource="empleados"
                   :pagination="false"
                   rowKey="id_emp" :scroll="{x: 2000, y: 500}"
                   :rowSelection="{selectedRowKeys: filasSeleccionadas,  onChange: filaSeleccionada}">
            <sm-input :slot="'itemRender'+(columna-1)"
                      slot-scope="text, record, fila"
                      v-model="empleados[fila].config[columna-1].value"
                      v-for="columna in 31"
                      :read-only="empleados[fila].config[columna-1].readOnly || roleVerInfo"
                      :editable="empleados[fila].config[columna-1].editable"
                      :loading="empleados[fila].config[columna-1].loading"
                      :valoresPermitidos="valoresPermitidos"
                      :festivo="festivos.includes(columna)"
                      :domingo="domingos.includes(columna)"
                      :notas="empleados[fila].config[columna-1].notas"
                      :color="(empleados[fila].config[columna-1].color === '1' ? 'green' :
                              empleados[fila].config[columna-1].color === '2' ? 'orange' :
                              empleados[fila].config[columna-1].color === '3' ? 'yellow' :
                              empleados[fila].config[columna-1].color === '4' ? 'red' :
                              empleados[fila].config[columna-1].color)"
                      :style="empleados[fila].config[columna-1].value
                            ? { border: '2px solid ' + (empleados[fila].config[columna-1].color === '1' ? 'green' :
                                                        empleados[fila].config[columna-1].color === '2' ? 'orange' :
                                                        empleados[fila].config[columna-1].color === '3' ? 'yellow' :
                                                        empleados[fila].config[columna-1].color === '4' ? 'red' :
                                                        empleados[fila].config[columna-1].color),
                                borderRadius: '5px'}
                            : {}"
                      @input="(value) => { columnaCambiada(empleados[fila], fila, columna-1, value) }"
                      @delete="() => {eliminarTurno(empleados[fila], fila, columna-1)}"
                      @agregarComentario="agregarComentario(empleados[fila], fila, columna-1)"
            ></sm-input>
            <span slot="nombreRenderer" slot-scope="text, record, index">
              <a-popover v-if="parseInt(record.reemplazo) > 0">
                <template slot="content">
                  {{record.nombre_reemplazado}}
                </template>
                <a-tag color="red">R</a-tag>
              </a-popover>
              {{text}}
              <strong v-if="verHorasProg">{{ record.valorHorasProg }}</strong>
              <a-tooltip title="Ver Detalle" v-if="verModalDetalle">
                <a-button shape="circle" icon="container" @click="verDetalle(record.id_emp)"/>
              </a-tooltip>
            </span>

            <div
              slot="filterDropdown"
              slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
              style="padding: 8px">
              <a-input
                v-ant-ref="c => (searchInput = c)"
                :placeholder="`Search ${column.dataIndex}`"
                :value="selectedKeys[0]"
                style="width: 188px; margin-bottom: 8px; display: block;"
                @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
              />
              <a-button
                type="primary"
                icon="search"
                size="small"
                style="width: 90px; margin-right: 8px"
                @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                Buscar
              </a-button>
              <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                Reset
              </a-button>
            </div>
            <a-icon
              slot="filterIcon"
              slot-scope="filtered"
              type="search"
              :style="{ color: filtered ? '#108ee9' : undefined }"
            />
            <template slot="customRender" slot-scope="text, record, index, column">
              <span v-if="searchText && searchedColumn === column.dataIndex">
              <template
                v-for="(fragment, i) in text
                  .toString()
                  .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
                <mark
                  v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                  :key="i"
                  class="highlight">
                  {{ fragment }}
                </mark>
                <template v-else>{{ fragment }}</template>
              </template>
              </span>
              <template v-else>
                {{ text }}
              </template>
            </template>
          </a-table>

          <a-table v-if="fechaSelector === 'rango'" size="small" :columns="columns" :dataSource="empleados"
                   :pagination="false"
                   rowKey="id_emp" :scroll="{x: 50, y: 500}"
                   :rowSelection="{selectedRowKeys: filasSeleccionadas,  onChange: filaSeleccionada}"
                   :style="{ padding: '0', margin: '0' }"
          >
            <sm-input
              :slot="'itemRender'+(columna-1)"
              slot-scope="text, record, fila"
              v-model="empleados[fila].config[columna-1].value"
              v-for="columna in 31"
              :read-only="empleados[fila].config[columna-1].readOnly || roleVerInfo"
              :editable="empleados[fila].config[columna-1].editable"
              :loading="empleados[fila].config[columna-1].loading"
              :valoresPermitidos="valoresPermitidos"
              :festivo="empleados[fila].config[columna-1].esFestivo"
              :domingo="empleados[fila].config[columna-1].esDomingo"
              :notas="empleados[fila].config[columna-1].notas"
              :color="(empleados[fila].config[columna-1].color === '1' ? 'green' :
                      empleados[fila].config[columna-1].color === '2' ? 'orange' :
                      empleados[fila].config[columna-1].color === '3' ? 'yellow' :
                      empleados[fila].config[columna-1].color === '4' ? 'red' :
                      empleados[fila].config[columna-1].color)"
              :style="empleados[fila].config[columna-1].value
                            ? { border: '1px solid ' + (empleados[fila].config[columna-1].color === '1' ? 'green' :
                                                        empleados[fila].config[columna-1].color === '2' ? 'orange' :
                                                        empleados[fila].config[columna-1].color === '3' ? 'yellow' :
                                                        empleados[fila].config[columna-1].color === '4' ? 'red' :
                                                        empleados[fila].config[columna-1].color),
                                borderRadius: '5px'}
                            : {}"
              @input="(value) => { columnaCambiada(empleados[fila], fila, columna-1, value) }"
              @delete="() => {eliminarTurno(empleados[fila], fila, columna-1)}"
              @agregarComentario="agregarComentario(empleados[fila], fila, columna-1)"
            />
            <span slot="nombreRenderer" slot-scope="text, record, index" style="padding: 0; margin: 0;">
              <a-popover v-if="parseInt(record.reemplazo) > 0">
                <template slot="content">
                  {{record.nombre_reemplazado}}
                </template>
                <a-tag color="red">R</a-tag>
              </a-popover>
              {{text}} <strong>{{ record.valorHorasProg }}</strong>
              <a-tooltip title="Ver Detalle" v-if="verModalDetalle">
                <a-button shape="circle" icon="container" @click="verDetalle(record.id_emp)"/>
              </a-tooltip>
            </span>

            <div
              slot="filterDropdown"
              slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
              style="padding: 8px">
              <a-input
                v-ant-ref="c => (searchInput = c)"
                :placeholder="`Search ${column.dataIndex}`"
                :value="selectedKeys[0]"
                style="width: 188px; margin-bottom: 8px; display: block;"
                @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
              />
              <a-button
                type="primary"
                icon="search"
                size="small"
                style="width: 90px; margin-right: 8px"
                @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                Buscar
              </a-button>
              <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                Reset
              </a-button>
            </div>
            <a-icon
              slot="filterIcon"
              slot-scope="filtered"
              type="search"
              :style="{ color: filtered ? '#108ee9' : undefined }"
            />
            <template slot="customRender" slot-scope="text, record, index, column">
              <span v-if="searchText && searchedColumn === column.dataIndex">
              <template
                v-for="(fragment, i) in text
                  .toString()
                  .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
                <mark
                  v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                  :key="i"
                  class="highlight">
                  {{ fragment }}
                </mark>
                <template v-else>{{ fragment }}</template>
              </template>
              </span>
              <template v-else>
                {{ text }}
              </template>
            </template>
          </a-table>

          <!-- Modal que carga la informacion de RhVOvertimeLiqTotales -->
          <a-modal
            :visible="modalVisible && verModalDetalle"
            @ok="handleOk"
            :cancel-button-props="{style: {display: 'none'} }"
            title="Detalle"
            width="80%"
            :closable="false">
            <a-divider style="margin-top: -10px" orientation="left">
              <div style="text-align: start;">TIEMPO LABORADO</div>
            </a-divider>
            <a-descriptions :column="3" bordered :size="'small'">
              <a-descriptions-item :label="$t('EMPLEADO')">
                {{ detalleData && detalleData[0] && detalleData[0].id_emp && detalleData[0].nombre_empleado ?
                detalleData[0].id_emp + ' ' + detalleData[0].nombre_empleado : 'No disponible' }}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('HORAS DE PROGRAMACIÓN')">
                {{ detalleData && detalleData[0] && detalleData[0].h_programacion_desc ?
                detalleData[0].h_programacion_desc : 'No disponible' }}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('HORAS DE MARCACIÓN')">
                {{ detalleData && detalleData[0] && detalleData[0].h_marcacion_desc ? detalleData[0].h_marcacion_desc :
                'No disponible' }}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('HORAS TOTALES')">
                {{ detalleData && detalleData[0] && detalleData[0].h_total_desc ? detalleData[0].h_total_desc :
                'No disponible' }}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('HORAS OBJETIVO')">
                {{ detalleData && detalleData[0] && detalleData[0].horas_mes_esesai ? detalleData[0].horas_mes_esesai :
                'No disponible' }}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('PORCENTAJE')">
                {{ detalleData && detalleData[0] && detalleData[0].porcentaje ? detalleData[0].porcentaje :
                'No disponible' }}
              </a-descriptions-item>
            </a-descriptions>

            <a-divider orientation="left">
              <div style="text-align: start;">HORAS EXTRAS</div>
            </a-divider>
            <a-descriptions :column="4" bordered :size="'small'">
              <a-descriptions-item :label="$t('HORAS EXT DIUR')">
                {{ detalleData && detalleData[0] && detalleData[0].horas_ext_diur ? detalleData[0].horas_ext_diur :
                'No disponible' }}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('HORAS EXT NOCT')">
                {{ detalleData && detalleData[0] && detalleData[0].horas_ext_noct ? detalleData[0].horas_ext_noct :
                'No disponible' }}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('HORAS EXT DIUR FESTIVO')">
                {{ detalleData && detalleData[0] && detalleData[0].horas_ext_diur_festivo ?
                detalleData[0].horas_ext_diur_festivo : 'No disponible' }}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('HORAS EXT NOCT FESTIVO')">
                {{ detalleData && detalleData[0] && detalleData[0].horas_ext_noct_festivo ?
                detalleData[0].horas_ext_noct_festivo : 'No disponible' }}
              </a-descriptions-item>
            </a-descriptions>

            <a-divider orientation="left">
              <div style="text-align: start;">RECARGOS</div>
            </a-divider>
            <a-descriptions :column="4" bordered :size="'small'">
              <a-descriptions-item :label="$t('HORAS_REC_NOCT')">
                {{ detalleData && detalleData[0] && detalleData[0].horas_rec_noct ? detalleData[0].horas_rec_noct :
                'No disponible' }}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('HORAS_REC_DIUR_DOMINGO')">
                {{ detalleData && detalleData[0] && detalleData[0].horas_rec_diur_domingo ?
                detalleData[0].horas_rec_diur_domingo : 'No disponible' }}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('HORAS_REC_NOCT_DOMINGO')">
                {{ detalleData && detalleData[0] && detalleData[0].horas_rec_noct_domingo ?
                detalleData[0].horas_rec_noct_domingo : 'No disponible' }}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('HORAS_REC_DIUR_FESTIVO')">
                {{ detalleData && detalleData[0] && detalleData[0].horas_rec_diur_festivo ?
                detalleData[0].horas_rec_diur_festivo : 'No disponible' }}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('HORAS_REC_NOCT_FESTIVO')">
                {{ detalleData && detalleData[0] && detalleData[0].horas_rec_noct_festivo ?
                detalleData[0].horas_rec_noct_festivo : 'No disponible' }}
              </a-descriptions-item>
            </a-descriptions>
          </a-modal>
        </a-tab-pane>
        <div slot="tabBarExtraContent">
          <a-button @click="() => {modalExtrashiftsVisible = true}" type="primary">
            Turnos extra
          </a-button>

          <!-- Selector de opción de fecha (Mes o Rango) -->
          <a-select v-model="fechaSelector" style="margin-left: 20px;" placeholder="Seleccione una opción">
            <a-select-option value="mes">Cargar info mes completo</a-select-option>
            <a-select-option value="rango">Cargar info rango de fechas</a-select-option>
          </a-select>

          <!-- Mostrar mes o rango según la opción seleccionada -->
          <a-month-picker v-if="fechaSelector === 'mes'" v-model="selectedMonth" placeholder="Seleccione un mes"
                          @change="mesCambiado" :disabled-date="disabledDate"/>
          <a-range-picker v-if="fechaSelector === 'rango'" v-model="selectedRange" :disabled-date="disabledDate"
                          format="YYYY-MM-DD" @change="mostrarRangoFechas"/>
        </div>

        <!-- Modal para Crear Turno Masivo -->
        <a-modal
          :visible="modalCrearTurnoMasivoVisible"
          @ok="handleCrearTurnoMasivo"
          @cancel="cerrarModalCrearTurnoMasivo"
          title="Crear Turno Masivo"
          width="50%"
          :confirmLoading="loading"
          :maskClosable="!loading"
          :closable="!loading"
          :okButtonProps="{ disabled: loading }"
          :cancelButtonProps="{ disabled: loading }"
        >
          <a-form>
            <a-row :gutter="16">
              <a-col v-bind="colOptions">
                <!--<a-form-item v-bind="fiOptions">-->
                <g-dropdown label="Turno Ingreso"
                            :selectedObj.sync="formularioCrearTurno.nombreTurno"
                            endpoint="shift_setup"
                            :formItemConfig="fiOptions">
                </g-dropdown>
                <!--                </a-form-item>-->
              </a-col>

              <a-col v-bind="colOptions">
                <a-form-item label="Horario" v-bind="fiOptions">
                  <a-range-picker
                    v-model="formularioCrearTurno.horaInicio"
                    valueFormat="Y-MM-DD 00:00:00"
                    format="Y-MM-DD"
                    style="width: 100%;"
                    :bordered="false"
                  />
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </a-modal>

        <!-- Modal para Agregar Comentario -->
        <a-modal
          :visible="modalAgregarComentarioVisible"
          @ok="handleAgregarComentarios"
          @cancel="cerrarModalAgregar"
          title="Agregar Comentario y Horas Aprobadas"
          width="30%">
          <a-form @submit="handleAgregarComentarios">
            <a-row :gutter="16">
              <a-col :span="24">
                <a-form-item label="Comentario">
                  <!-- TEXTAREA -->
                  <a-textarea
                    v-if="tipoCampoComentario === 'TEXTAREA'"
                    v-model="comentario"
                    placeholder="Ingrese el comentario"
                  />

                  <!-- LISTA -->
                  <g-dropdown
                    v-else
                    endpoint="hierarchy_lookup"
                    :params="{ h_lookup_type: 'CAMPO_COMENTARIO_TURNOS', use_description: true }"
                    :selectedObj.sync="comentarioSeleccionado"
                    :formItemConfig="{ label: '', 'label-col': {span: 0}, 'wrapper-col': {span: 24} }"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="Cantidad de horas aprobadas">
                  <a-input v-model="cantidad_haprob"/>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="Fecha">
                  <a-input v-model="fecha_comentario" disabled/>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </a-modal>
      </a-tabs>
      <modal-extra-shifts :visible="modalExtrashiftsVisible" :month="selectedMonth"
                          @ok="() => {modalExtrashiftsVisible = false}"></modal-extra-shifts>
    </div>
  </a-spin>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import DateUtils from '@/util/DateUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        responsive: {
          cTurnoCfg: {
            xs: {span: 24}
          }
        },
        selectedMonth: moment(),
        grupoSeleccionado: {},
        puestoSeleccionado: {},
        turnoSeleccionado: {},
        listas: {
          grupos: [],
          puestos: [],
          iniciales: []
        },
        filasSeleccionadas: [],
        formCargar: this.$form.createForm(this, {
          name: 'frmCargar'
        }),
        formAplicar: this.$form.createForm(this, {
          name: 'frmAplicar'
        }),
        decoradores: {
          valor_requerido: {rules: [{required: true, message: 'Valor requerido'}]}
        },
        turno: null,
        inicial: null,
        numero: 6,
        columns: [],
        empleados: [],
        loading: false,
        valoresPermitidos: [],
        modalExtrashiftsVisible: false,
        festivos: [],
        domingos: [],
        id_h_att3: {
          h_lookup_type: 'ID_H_ATT3'
        },
        visible_id_h_att3: this.$getConfigValue('MOSTRAR_ID_H_ATT3_TURNO', 'NO') === 'SI',
        can_view_groups: this.$getConfigValue('CAN_VIEW_GROUPS', 'NO') === 'SI',
        verModalDetalle: this.$getConfigValue('VER_MODAL_TURNOS_DETALLE_HORAS', 'NO') === 'SI',
        verHorasProg: this.$getConfigValue('VER_VALOR_HORAS_PROG', null) === 'SI',
        comentarioSeleccionado: null,
        tipoCampoComentario: this.$getConfigValue('CAMPO_COMENTARIO_TURNOS', 'TEXTAREA'),
        modalVisible: false,
        detalleData: [],
        modalCrearTurnoMasivoVisible: false,
        formularioCrearTurno: {
          nombreTurno: null,
          horaInicio: null
        },
        popoverContent: '',
        modalAgregarComentarioVisible: false,
        comentario: '',
        fecha_comentario: '',
        empleado_comentario: '',
        cantidad_haprob: '',
        fechaSelector: 'mes', // Valor por defecto (puede ser 'mes' o 'rango')
        selectedRange: [],
        selectedStartDate: null,
        selectedEndDate: null
      }
    },
    async created () {
      this.valoresPermitidos = await new Promise(resolve => {
        HttpUtil.getStaticInstance().get('ct/opciones_disponibles').then(response => {
          resolve(response.data)
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible cargar las opciones permitidas.')
          resolve([])
        })
      })
    },
    mounted () {
      this.http = new HttpUtil()
      this.initDataTable()
      this.fetchPopoverContent()
    },
    methods: {
      verDetalle (id) {
        this.loading = true
        this.http.getInstance().get('ct/consultar_total_empleados', {
          params: {
            id_emp: id,
            grupo: this.grupoSeleccionado.value,
            puesto: this.puestoSeleccionado.value
          }
        }).then((response) => {
          this.detalleData = response.data
          this.modalVisible = true
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible cargar los totales empleados, contacte a mesa de ayuda.')
        }).then(() => {
          this.loading = false
        })
      },
      closeModal () {
        this.modalVisible = false
      },
      handleOk () {
        this.closeModal()
      },
      handleSearch (selectedKeys, confirm, dataIndex) {
        confirm()
        this.searchText = selectedKeys[0]
        this.searchedColumn = dataIndex
      },
      handleReset (clearFilters) {
        clearFilters()
        this.searchText = ''
      },
      mesCambiado (e) {
        this.initDataTable()
      },
      mostrarRangoFechas (dates) {
        const [startDate, endDate] = dates
        this.selectedStartDate = startDate ? startDate.format('YYYY-MM-DD 00:00:00') : null
        this.selectedEndDate = endDate ? endDate.format('YYYY-MM-DD 00:00:00') : null

        // Actualiza las columnas de la tabla con los nuevos días
        this.initDataTable()
      },
      obtenerValorEmpleado (id, startDate, endDate, seleccion, periodoMes) {
        return this.http.getInstance().get('ct/obtener_valor_horas_prog', {
          params: {
            id_emp: id,
            rango_start_date: startDate,
            rango_end_date: endDate,
            seleccion: seleccion,
            periodo_mes: periodoMes
          }
        }).then(response => {
          return response.data.message
        }).catch(() => {
          return 'No fue posible obtener los valores'
        })
      },
      cargarEmpleados (e) {
        e.preventDefault()
        if (this.loading) {
          return
        }
        this.formCargar.validateFields((err, values) => {
          if (!err) {
            this.loading = true
            this.empleados.splice(0, this.empleados.length)

            this.http.getInstance().get('ct/consultar_empleados', {
              params: {
                rango_start_date: this.selectedStartDate,
                rango_end_date: this.selectedEndDate,
                periodo: DateUtils.forBackEnd(this.selectedMonth),
                grupo: values.grupo,
                puesto: values.puesto,
                id_h_att3: values.id_h_att3,
                seleccion: this.fechaSelector
              }
            }).then(async (response) => {
              this.empleados.splice(0, this.empleados.length)
              let empleados = response.data.empleados

              await Promise.all(empleados.map(async (empleado, index) => {
                try {
                  let valorHorasProg = 0

                  if (this.verHorasProg) {
                    valorHorasProg = await this.obtenerValorEmpleado(
                      empleado.id_emp,
                      this.selectedStartDate,
                      this.selectedEndDate,
                      this.fechaSelector,
                      DateUtils.forBackEnd(this.selectedMonth)
                    )
                  }

                  this.$nextTick(() => this.$forceUpdate())
                  this.$set(empleados[index], 'valorHorasProg', valorHorasProg)
                } catch (error) {
                  this.$set(empleados[index], 'valorHorasProg', null)
                }
              }))

              if (this.fechaSelector === 'rango' && this.selectedStartDate && this.selectedEndDate) {
                let festivos = (response.data.festivos || []).map(f => moment(f, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'))
                let startDate = moment(this.selectedStartDate)
                let endDate = moment(this.selectedEndDate)
                let diasEnRango = endDate.diff(startDate, 'days') + 1
                let anioMesActual = moment().format('YYYY-MM')

                let domingosPorMes = {}
                for (let fecha = startDate.clone(); fecha.isBefore(endDate) || fecha.isSame(endDate); fecha.add(1, 'day')) {
                  if (fecha.day() === 0) {
                    let claveMes = fecha.format('YYYY-MM')
                    if (!domingosPorMes[claveMes]) {
                      domingosPorMes[claveMes] = []
                    }
                    domingosPorMes[claveMes].push(fecha.date())
                  }
                }
                this.domingos = domingosPorMes
                this.festivos = festivos

                this.empleados = empleados.map((empleado) => {
                  let configArray = {}

                  for (let idx = 0; idx < diasEnRango; idx++) {
                    let fechaColumna = startDate.clone().add(idx, 'days')
                    let fechaColumnaStr = fechaColumna.format('YYYY-MM-DD')
                    let configDia = Object.values(empleado.config).find(
                      (config) => moment(config.fecha, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') === fechaColumnaStr
                    )
                    let mesDelDia = fechaColumna.format('YYYY-MM')
                    let diaDelMes = fechaColumna.date()
                    let esDomingo = (this.domingos[mesDelDia] || []).includes(diaDelMes)
                    let esFestivo = festivos.includes(fechaColumnaStr)
                    let esMesActual = mesDelDia === anioMesActual

                    if (configDia) {
                      configArray[idx] = {
                        ...configDia,
                        loading: false,
                        esDomingo,
                        esFestivo
                      }
                    } else {
                      configArray[idx] = {
                        fecha: fechaColumnaStr,
                        value: '',
                        editable: esMesActual,
                        readOnly: !esMesActual,
                        loading: false,
                        esDomingo,
                        esFestivo,
                        color_alerta: 'white'
                      }
                    }
                  }
                  return {...empleado, config: configArray}
                })

                this.initDataTable()
                this.$nextTick(() => this.$forceUpdate())
              } else if (this.fechaSelector === 'mes') {
                this.festivos = response.data.festivos
                this.domingos = response.data.domingos
                empleados.forEach((empleado) => {
                  this.empleados.push(empleado)
                })
              }
            }).catch(() => {
              Mensajes.error('Error', 'No fue posible cargar los empleados, contacte a mesa de ayuda.')
            }).then(() => {
              this.loading = false
            })
          }
        })
      },
      aplicarSecuencia (e) {
        e.preventDefault()
        this.formAplicar.validateFields((err, values) => {
          if (!err) {
            this.filasSeleccionadas.map(key => {
              let empleado = this.buscaEmpelado(key)
              if (empleado !== null) {
                let cambiado = false
                /* debo generar la secuencia iniciando con values.inicial */
                let consecutivoSecuencia = values.inicial

                /* Segun el periodo seleccionado debes iniciar en 0 o en 15 */
                let diaInicio = values.periodo !== '4' ? 0 : 15
                let diaFin = values.periodo === '2' ? 15 : empleado.config.length

                for (let dialDelMes = diaInicio; dialDelMes < diaFin; dialDelMes++) {
                  /* por cada dia del mes debo asihnar una secuencia */
                  let config = empleado.config[dialDelMes]
                  if (config.editable) {
                    config.value = this.listas.iniciales[consecutivoSecuencia].text
                    cambiado = true
                  }
                  consecutivoSecuencia++
                  if (consecutivoSecuencia === this.listas.iniciales.length) {
                    consecutivoSecuencia = 0
                  }
                }
                if (cambiado) {
                  this.actualizarEmpleado(empleado)
                } else {
                  Mensajes.warning('Advertencia', 'No es posible actualizar el empleado ' + empleado.nombre)
                }
              }
            })
          }
        })
      },
      columnaCambiada (empleado, fila, columna, value) {
        if (!empleado.config[columna].editable) {
          return
        }
        empleado.config[columna].readOnly = true
        empleado.config[columna].loading = true

        let fechaRequest = moment(this.selectedMonth)
        fechaRequest.date(columna + 1)

        this.http.getInstance().post('ct/actualizar_turno', {
          fecha: DateUtils.forBackEnd(fechaRequest),
          id_emp: empleado.id_emp,
          id_shift: value,
          grupo: this.grupoSeleccionado.value,
          puesto: this.puestoSeleccionado.value
        })
          .then((response) => {
            empleado.config[columna].readOnly = false
            empleado.config[columna].loading = false
          })
          .catch((error) => {
            Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible actualizar la marcación, contacte a mesa de ayuda.'))
          })
          .then(() => {
            empleado.config[columna].readOnly = false
            empleado.config[columna].loading = false
          })
      },
      actualizarEmpleado (empleado) {
        let setup = []
        let fechaRequest = moment(this.selectedMonth)
        let dia = 1
        empleado.config.map(config => {
          if (config.editable && !JsUtils.isEmpty(config.value)) {
            config.readOnly = true
            config.loading = true
            fechaRequest.date(dia++)
            setup.push({
              id_shift: config.value,
              fecha: DateUtils.forBackEnd(fechaRequest)
            })
          } else {
            dia++
          }
        })

        this.http.getInstance().post('ct/actualizar_turno_masivo', {
          id_emp: empleado.id_emp,
          setup: setup,
          grupo: this.grupoSeleccionado.value,
          puesto: this.puestoSeleccionado.value
        })
          .then((response) => {
            empleado.config.map(config => {
              if (config.editable) {
                config.readOnly = false
                config.loading = false
              }
            })
          })
          .catch((error) => {
            Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible actualizar la marcación, contacte a mesa de ayuda.'))
          })
          .then(() => {
            empleado.config.map(config => {
              if (config.editable) {
                config.readOnly = false
                config.loading = false
              }
            })
          })
      },
      eliminarTurnos (e) {
        e.preventDefault()
        if (this.loading) {
          return
        }

        this.loading = true
        let request = {
          fecha: DateUtils.forBackEnd(moment(this.selectedMonth)),
          empleados: this.filasSeleccionadas,
          rango_start_date: this.selectedStartDate,
          rango_end_date: this.selectedEndDate,
          seleccion: this.fechaSelector
        }

        this.http.getInstance().post('ct/eliminar_turnos', request)
          .then((response) => {
            this.loading = false
            this.cargarEmpleados(e)
            this.filasSeleccionadas = []
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible eliminar los turnos.')
            this.loading = false
          })
      },
      initDataTable () {
        this.columns.splice(0, this.columns.length)
        let startDate = moment(this.selectedStartDate)
        let endDate = moment(this.selectedEndDate)
        let maxDay = this.getUltimoDiaDelMes()
        this.columns.push({
          title: 'Empleado',
          dataIndex: 'nombre',
          key: 'nombre',
          fixed: 'left',
          width: 340,
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'nombreRenderer'
          },
          onFilter: (value, record) =>
            record.nombre
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus()
              }, 0)
            }
          }

        })
        if (this.fechaSelector === 'rango') {
          if (this.selectedStartDate && this.selectedEndDate) {
            maxDay = endDate.diff(startDate, 'days') + 1
            // Agregar columnas dinámicas para cada día en el rango seleccionado
            for (let i = 0; i < maxDay; i++) {
              let date = startDate.clone().add(i, 'days')
              this.columns.push({
                title: date.format('DD') + ' ' + date.format('ddd'),
                dataIndex: `config[${i}]`, // Asegúrate de que el índice corresponda
                scopedSlots: {customRender: `itemRender${i}`},
                width: 70
              })
            }
          }
        } else {
          for (let i = 1; i <= maxDay; i++) {
            this.columns.push({
              title: (i < 10 ? '0' + i : i) + ' ' + this.getDayOfWeek(i),
              dataIndex: 'config[' + (i - 1) + ']',
              scopedSlots: {customRender: 'itemRender' + (i - 1)},
              width: 70
            })
          }
        }
      },
      filaSeleccionada (selectedRowKeys) {
        this.filasSeleccionadas = selectedRowKeys
      },
      buscaEmpelado (key) {
        for (let i = 0; i < this.empleados.length; i++) {
          if (this.empleados[i].id_emp === key) {
            return this.empleados[i]
          }
        }
        return null
      },
      getUltimoDiaDelMes () {
        return this.selectedMonth.endOf('month').date()
      },
      getDayOfWeek (day) {
        return moment(this.selectedMonth).date(day).format('ddd')
      },
      disabledDate (current) {
        return current &&
          (
            current.year() > moment().year()
          )
      },
      grupoCambiado () {
        this.formCargar.setFieldsValue({
          puesto: undefined
        })
      },
      eliminarTurno (empleado, fila, columna) {
        if (!empleado.config[columna].editable) {
          return
        }

        this.$confirm({
          title: 'Confirmación',
          content: '¿Está seguro que desea continuar?',
          okText: 'Si',
          okType: 'danger',
          cancelText: 'No',
          onOk: () => {
            return new Promise((resolve, reject) => {
              empleado.config[columna].readOnly = true
              empleado.config[columna].loading = true

              let fechaRequest = moment(this.selectedMonth)
              fechaRequest.date(columna + 1)

              this.http.getInstance().post('ct/eliminar_turno', {
                fecha: DateUtils.forBackEnd(fechaRequest),
                id_emp: empleado.id_emp,
                grupo: this.grupoSeleccionado.value,
                puesto: this.puestoSeleccionado.value
              })
                .then((response) => {
                  empleado.config[columna].readOnly = false
                  empleado.config[columna].loading = false
                  empleado.config[columna].value = ''
                  Mensajes.success('Correcto', 'Registro eliminado exitosamente.')
                  resolve()
                })
                .catch((error) => {
                  let errorMessage = this.$getErrorMessage(error, 'No fue posible eliminar la marcación, contacte a mesa de ayuda.')
                  Mensajes.error('Error', errorMessage)
                  reject(errorMessage)
                })
                .then(() => {
                  empleado.config[columna].readOnly = false
                  empleado.config[columna].loading = false
                })
            })
          },
          onCancel () {}
        })
      },
      abrirModalCrearTurnoMasivo () {
        this.modalCrearTurnoMasivoVisible = true
      },
      cerrarModalCrearTurnoMasivo () {
        this.modalCrearTurnoMasivoVisible = false
        this.resetFormularioCrearTurno()
      },
      resetFormularioCrearTurno () {
        this.formularioCrearTurno.nombreTurno = null
        this.formularioCrearTurno.horaInicio = null
      },
      handleCrearTurnoMasivo (e) {
        e.preventDefault()
        if (this.loading) {
          return
        }

        this.loading = true

        this.http.getInstance().post('ct/crear_turnos_masivos', {
          fecha: DateUtils.forBackEnd(moment(this.selectedMonth)),
          empleados: this.filasSeleccionadas,
          f_ini: this.formularioCrearTurno.horaInicio[0],
          f_fin: this.formularioCrearTurno.horaInicio[1],
          id_turno: this.formularioCrearTurno.nombreTurno.value,
          grupo: this.grupoSeleccionado.value,
          puesto: this.puestoSeleccionado.value
        }).then((response) => {
          if (response.data.message === 'OK') {
            Mensajes.success('Turnos creados exitosamente')
            this.cerrarModalCrearTurnoMasivo()
            this.loading = false
            this.cargarEmpleados(e)
          }
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible crear los turnos, contacte a mesa de ayuda.')
        }).then(() => {
          this.loading = false
        })
      },
      groupContent (array, size) { // Método para dividir el arreglo en subarreglos de un tamaño específico
        const groups = []
        for (let i = 0; i < array.length; i += size) {
          groups.push(array.slice(i, i + size))
        }
        return groups
      },
      fetchPopoverContent () {
        this.http.getInstance().get('shift_setup_/obtener_turnos')
          .then(response => {
            let groupedContent = this.groupContent(response.data.message, 4)

            this.popoverContent = groupedContent.map(group =>
              `<div style="display: flex; flex-wrap: wrap; gap: 10px;">` +
              group.map(item => `<span style="flex: 1 0 22%">${item}</span>`).join('') +
              `</div>`
            ).join('')
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posble consultar la info')
            this.popoverContent = 'Error al cargar los detalles'
          })
      },
      abrirModalAgregarComentario () {
        this.modalAgregarComentarioVisible = true
      },
      cerrarModalAgregar () {
        this.modalAgregarComentarioVisible = false
        this.comentarioSeleccionado = null
        this.fecha_comentario = null
        this.cantidad_haprob = null
      },
      handleAgregarComentarios (e) {
        e.preventDefault()
        if (this.loading) {
          return
        }

        this.loading = true
        const comentarioValido = this.tipoCampoComentario === 'TEXTAREA'
          ? this.comentario
          : (this.comentarioSeleccionado && this.comentarioSeleccionado.value)

        if (comentarioValido && this.fecha_comentario) {
          const payload = {
            comentario: this.tipoCampoComentario === 'TEXTAREA'
              ? this.comentario
              : (this.comentarioSeleccionado ? this.comentarioSeleccionado.value : null),
            fecha: this.fecha_comentario,
            fecha_filtro: DateUtils.forBackEnd(moment(this.selectedMonth)),
            empleado: this.empleado_comentario,
            grupo: this.grupoSeleccionado.value,
            puesto: this.puestoSeleccionado.value,
            horas_aprobadas: this.cantidad_haprob
          }

          this.http.getInstance().post('ct/agregar_comentario_turno', payload
          ).then(response => {
            if (response.status === 200) {
              Mensajes.success(response.data.message)
              this.cerrarModalAgregar()
              this.loading = false
              this.cargarEmpleados(e)
            }
          }).catch(error => {
            let mensaje = 'Error al guardar el comentario'

            if (error && error.response && error.response.data && error.response.data.message) {
              mensaje = error.response.data.message
            }

            Mensajes.error('Error', mensaje)
            this.loading = false
          })
        } else {
          this.$message.error('Por favor, complete todos los campos')
        }
      },
      agregarComentario (empleado, fila, columna) {
        // Guardar empleado y columna seleccionada
        this.empleadoSeleccionado = empleado
        this.columnaSeleccionada = columna

        // Obtener la fecha de la celda seleccionada
        this.fecha_comentario = empleado.config[columna].fecha ||
          moment(this.selectedMonth).date(columna + 1).format('YYYY-MM-DD 00:00:00')

        this.empleado_comentario = empleado.id_emp

        this.abrirModalAgregarComentario()
      }
    },
    watch: {
      turnoSeleccionado () {
        this.listas.iniciales.splice(0, this.listas.iniciales.length)
        this.formAplicar.setFieldsValue({
          inicial: undefined
        })
        if (!JsUtils.isEmpty(this.turnoSeleccionado)) {
          this.turnoSeleccionado.shifts_master.map((secuencia, index) => {
            this.listas.iniciales.push({
              value: index, text: secuencia.id_shift
            })
          })
        }
      }
    },
    computed: {
      secuencia () {
        if (JsUtils.isEmpty(this.turnoSeleccionado)) {
          return ''
        }
        let concat = ''
        this.turnoSeleccionado.shifts_master.map((secuencia) => {
          concat += secuencia.id_shift + '|'
        })
        return (concat + '|').replace('||', '')
      },
      grupoParams () {
        // por solicitud de KR se cambia grupo_turno por id_h_att1 15/04/2020
        return {h_lookup_type: 'ID_H_ATT1', custom_handler: 'grupo_lleno', can_view_groups: this.can_view_groups}
      },
      puestoParams () {
        return {
          // por solicitud de KR se cambia puesto_turno por id_h_att2 15/04/2020
          h_lookup_type: 'ID_H_ATT2',
          custom_handler: 'puesto_lleno',
          id_h_lookup_father: this.grupoSeleccionado.value ? this.grupoSeleccionado.value : -1
        }
      },
      roleCrearTurnoMasivo () {
        return this.$userIsInrol('CrearTurnosMasivo')
      },
      roleAgregarComentario () {
        return this.$userIsInrol('AgregarComentarioTurnos')
      },
      roleVerFormCambioTurno () {
        return this.$userIsInrol('VerFormCambioTurno')
      },
      roleVerInfo () {
        return this.$userIsInrol('SinAccionesOpcTurnos')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/ShiftsManagement/ShiftsManagement.vue